export const sortMenu = [
  {
    id: 1,
    title: "Latest",
  },
  {
    id: 2,
    title: "Featured",
  },
  {
    id: 3,
    title: "Top Rated",
  },
  {
    id: 4,
    title: "Price(Lowest First)",
  },
  {
    id: 5,
    title: "Price(Highest First)",
  },
];

export const brandsMenu = [
  {
    id: 1,
    label: "JBL",
    checked: false,
  },
  {
    id: 22,
    label: "Headphones",
    checked: false,
  },
  {
    id: 2,
    label: "Inverter",
    checked: false,
  },
  {
    id: 3,
    label: "Battery",
    checked: false,
  },
  {
    id: 4,
    label: "Gamepad",
    checked: false,
  },
  {
    id: 5,
    label: "Mouse",
    checked: false,
  },
  {
    id: 6,
    label: "Electronics",
    checked: false,
  },
  {
    id: 7,
    label: "SmartWatch",
    checked: false,
  },
];

export const categoryMenu = [
  {
    id: 0,
    label: "Headphones",
    checked: false,
  },
  {
    id: 1,
    label: "JBL",
    checked: false,
  },
  {
    id: 2,
    label: "Inverter",
    checked: false,
  },
  {
    id: 3,
    label: "Battery",
    checked: false,
  },
  {
    id: 4,
    label: "Gamepad",
    checked: false,
  },
  {
    id: 5,
    label: "Mouse",
    checked: false,
  },
  {
    id: 6,
    label: "Electronics",
    checked: false,
  },
  {
    id: 7,
    label: "SmartWatch",
    checked: false,
  },
];
